export default "__VITE_ASSET__tcfzcOVB__"